import { useMemo } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "@/components/base/Breadcrumbs";
import CategoryCard from "@/components/base/CategoryCard";
import { useSeo } from "@/hooks/useSeo";
import { categories } from "@/mocks/categories";

function CategoriesPage() {
  const jsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "主题分类 - 爆料平台",
      description: "爆料平台的主题分类总览，按内部消息、公众事件、身边事、维权线索等归类线索。",
      url: "https://gregbennettguitars.com.cn/categories",
      inLanguage: "zh-CN",
      mainEntity: {
        "@type": "ItemList",
        numberOfItems: categories.length,
        itemListElement: categories.map((category, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: category.name,
          url: `https://gregbennettguitars.com.cn/category/${category.slug}`,
        })),
      },
    }),
    []
  );

  useSeo({
    title: "主题分类 - 内部消息 / 公众事件 / 维权线索 | 爆料平台",
    description:
      "爆料平台按主题对线索进行归类，涵盖内部消息、公众事件、身边事、维权线索、消费投诉与行业观察六大分类，方便集中查找与跟进同类问题。",
    keywords: "主题分类,内部消息,公众事件,身边事,维权线索,爆料平台",
    path: "/categories",
    jsonLd,
  });

  return (
    <div className="w-full bg-background-50">
      <div className="border-b border-background-200 bg-background-100">
        <div className="w-full px-4 py-10 md:px-8 md:py-14">
          <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "主题分类" }]} />
          <h1 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
            主题分类
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            线索按主题归档，方便集中处理同类问题。如果你手里的材料不属于现有分类，也可以在投稿时自行说明，我们会按实际情况新建归类。
          </p>
        </div>
      </div>

      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category) => (
            <CategoryCard key={category.slug} category={category} />
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 gap-4 rounded-lg border border-background-200 bg-background-100 p-6 md:grid-cols-3 md:p-8">
          {categories.slice(0, 3).map((category) => (
            <div key={category.slug} className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${category.icon} text-lg`} />
              </span>
              <div>
                <h3 className="font-heading text-sm font-bold text-foreground-950">
                  {category.name}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                  已归档 {category.count} 条线索
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-foreground-500">
          没找到合适的分类？
          <Link to="/submit" className="link-underline ml-1 font-medium text-primary-600">
            直接匿名提交，由我们归类
          </Link>
        </p>
      </div>
    </div>
  );
}

export default CategoriesPage;